var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M10.5 10.5H13V13h-2.5zM8.5 8.5h2v2h-2zM13 13h2v2h-2zM13.5 8.5H15V10h-1.5zM8.5 13.5H10V15H8.5zM10.5 3H13v2.5h-2.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M15 7.5H8.5V1H15zM9.875 6.125h3.75v-3.75h-3.75zM3 3h2.5v2.5H3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M7.5 7.5H1V1h6.5zM2.375 6.125h3.75v-3.75h-3.75zM3 10.5h2.5V13H3z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "M7.5 15H1V8.5h6.5zm-5.125-1.375h3.75v-3.75h-3.75z"
})));
export { SvgQr as ReactComponent };
export default __webpack_public_path__ + "QR.75d602d2.svg";